import clsx from "clsx"
import { FC, memo } from "react"
import { useTranslation } from "react-i18next"
import { useModals } from "@/modals"
import { useGame } from "@/providers/GameProvider"
import { Button } from "@/ui/Button"
import { OutlinedText } from "@/ui/OutlinedText"
import { IUserInfo } from "."
import styles from "./UserInfo.module.scss"

const UserInfoComponent: FC<IUserInfo> = ({
  playerInfo,
  playerStatistics,
  name
}) => {
  const { t } = useTranslation()
  const { openModal } = useModals()
  const { checkWinGame, isMatchFinished } = useGame()

  const handlePlayerInfo = () => {
    openModal("matchPlayer", { playerId: playerInfo?.player ?? "" })
  }

  const isWinner = checkWinGame(playerInfo?.player ?? "")

  return (
    <div className={styles.UserInfo}>
      <div className={styles.UserInfo_name}>
        <div className={styles.UserInfo_name_text}>
          <div>{name || t("player")}</div>
        </div>
        <Button.Info
          className={styles.UserInfo_name_button}
          onClick={handlePlayerInfo}
        />
      </div>
      {isMatchFinished && (
        <OutlinedText
          className={clsx(styles.UserInfo_status, {
            [styles.winner]: isWinner,
            [styles.loser]: !isWinner
          })}
        >
          {isWinner ? t("winner") : t("loser")}
        </OutlinedText>
      )}
      <OutlinedText className={styles.UserInfo_winners}>
        W: {playerStatistics?.totalWinGames ?? 0}
      </OutlinedText>
      <OutlinedText className={styles.UserInfo_losers}>
        L: {playerStatistics?.totalLoseGames ?? 0}
      </OutlinedText>
    </div>
  )
}

export const UserInfo = memo(UserInfoComponent)
